import React from 'react'
import {NavLink} from 'react-router-dom';

import { Pages } from 'pages/pages';
import { APPLICATIONS_PAGE_TITLE } from 'common/constants';
import {CustomerPermission, InitContextProps, isAccessibleForRoles, useAuthContext} from "../../services/context/authentication.context";

export function MobileMenu(props: { isOpen: boolean, action: any }) {
  const { state, hasPermission }: InitContextProps = useAuthContext();

  const accessiblePages = Pages
    .filter(page => isAccessibleForRoles(page.requiredRoles, state.customer))
    .filter(page => !page.onlyShowForPersons || (state.customer && state.customer.isPerson))
    .filter(page => !page.onlyShowForCompany || (state.customer && !state.customer.isPerson))
    .filter(page => !page.mustHaveGroupId || (state.customer && page.mustHaveGroupId.includes(state.customer.groupId)))
    .filter(page => page.title !== APPLICATIONS_PAGE_TITLE || state.customer.hasApplications)
    .filter(page => !page.onlyShowForRepresentative || hasPermission(CustomerPermission.REPRESENTATIVE));

  return (
    <div
      className={props.isOpen ? 'mobile-menu open ' : 'mobile-menu '}
      onClick={props.action}
    >
      <div className='d-flex justify-content-end p-3 mb-5'>
        <button
          type='button'
          className='d-flex align-items-center my-2 btn btn-light'
        >
          <i className='icon__close--masked' />
        </button>
      </div>
      <div className='d-flex flex-column justify-content-between px-5 mb-5'>
        <ul className='nav d-flex flex-column align-items-center my-5 mx-5'>
          {accessiblePages.map((page) => page.showInNav
            ?
            <li key={page.title} className='mb-3'>
              <NavLink
                to={`/${page.title}`}
                className='text-capitalize text-decoration-none'
                activeClassName='active'
                >
                {page.title}
              </NavLink>
            </li>
            : '')
          }
        </ul>
      </div>
        <div className='mobile-menu__footer-illustration'/>
        <div className='mobile-menu__footer'/>
    </div>
  )
}
